import Subtitle from "../Typography/Subtitle"
import { Box } from "../primitives"
function TitleCard({ title, children, topMargin, TopSideButtons }) {
    return (
        <Box css={{ backgroundColor: '$gray3' }} className={"card w-full transform transition duration-500 bg-base-100 shadow-xl hover:border-sky-500 hover:shadow-2xl hover:scale-105" + (topMargin || "mt-6")} data-wow-delay=".1s">
            {/* Title for Card */}
            <Subtitle styleClass={TopSideButtons ? "inline-block" : ""}>
                <Box className='p-4'>
                    {title}

                    {/* Top side button, show only if present */}
                    {
                        TopSideButtons && <Box className="inline-block float-right">{TopSideButtons}</Box>
                    }
                </Box>
            </Subtitle>

            <Box className="divider mt-2" css={{ borderBottom: '1px solid $gray7', borderStyle: 'solid' }}></Box>

            {/** Card Body */}
            <Box className='h-full w-full pb-6 bg-base-100'>
                {children}
            </Box>
        </Box>
    )
}

export default TitleCard